import 'datatables.net';
import $ from 'jquery';
import React, {memo, useEffect, useState} from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import '../../Styles/Projekte.css';
//import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import {useHistory} from "react-router-dom";
import moment from "moment";
import {getOut, getToken} from "../../Utils/Common";
//import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
//import {faPlus} from "@fortawesome/free-solid-svg-icons";
import Select from 'react-select'

let options = [{label:"test",value:"test"}]


let apiBody = {
    "token": getToken(), "data": {
        "organisationID": sessionStorage.getItem("org")
    }
}

let listofProjects = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/readprojects", {
    method: 'POST', headers: {
        'Content-type': 'application/json',
    }, body: JSON.stringify(apiBody),
})
    .then((response) => response.json())
    .catch((error) => {
        console.error('Error:', error);
    })
if (listofProjects.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
} else {
    options = listofProjects.data.map(a => ({"label": a.projectName, "value": a.projectID}));
}

function MetaComponent() {

    const [metaTableBody, setMetaTableBody] = useState(<></>);
    let history = useHistory();

    let prepareMetaTableBody = (result) => {
        let metaTableBodyData = result.map(({
                                                _id,
                                                date,
                                                type,
                                                creatorFirstName,
                                                creatorLastName,
                                                dataID,
                                                statusTracking,
                                                title,
                                                webreportURL,projectID
                                            }) => {
            return <tr key={_id}>
               <td data-order={"DD-MM-YYYY"}>{moment(date).format("DD-MM-YYYY")}</td>
                <td>{type}</td>
                {title!==""&&<td>{title}</td>}{title===""&&<td>-</td>}
                <td>{creatorFirstName + " " + creatorLastName}</td>
                <td>{statusTracking[statusTracking.length - 1].status}</td>
                <td className='centerStyle'><Button
                    onClick={() => {
                        if (type === "Tätigkeit") {
                            history.push(process.env.REACT_APP_FRONTEND_PATH_TAETIGKEITSBERICHTPAGE, {
                                dataID: dataID,type:type,
                                tstatus: statusTracking[statusTracking.length - 1].status
                            })
                        } else if(type === "Tages") {
                            history.push(process.env.REACT_APP_FRONTEND_PATH_TAGESBERICHTREPORTPAGE, {
                                dataID: dataID, status: statusTracking[statusTracking.length - 1].status,
                                type:statusTracking[statusTracking.length - 1].type,
                                date:moment(date).format("DD-MM-YYYY"),
                                reportView:true,
                                projectID:projectID


                            })
                        } else {
                            history.push(process.env.REACT_APP_FRONTEND_PATH_STUNDENPAGE, {
                                dataID: dataID, status: statusTracking[statusTracking.length - 1].status,
                                type:statusTracking[statusTracking.length - 1].type,
                                date:moment(date).format("DD-MM-YYYY")
                            })
                        }

                    }}

                    className='handwai-btn-create'>Öffnen</Button>{' '}</td>

                <td className='centerStyle'><Button
                    onClick={()=>
            {
                window.open(webreportURL,"_blank",'noopener=true')}
            }
                    className='handwai-btn-create' disabled={webreportURL===""}>Webreport</Button>{' '}</td>
            </tr>
        });

        setMetaTableBody(metaTableBodyData);

    };

    useEffect(async () => {
        // Datatable initialisation
        $('#metaTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            },
            //order: [[1, 'asc']],

        });

    }, []);

    return (<>
        <br/> <br/>
        <div className='container handwai-dark'>
            <Row>
                <Col md={3}>
                    <Select options={options}
                            placeholder={"Projekt auswählen:"}
                            onChange={async (e) => {
                                  sessionStorage.setItem("projectID", e.value)
                                  sessionStorage.setItem("projectName", e.label)
                                  let apiBody = {
                                      "token": getToken(), "data": {
                                          "organisationID": sessionStorage.getItem("org")
                                      }
                                  }
                                  let serverResponse = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/get_allmetaobjects", {
                                      method: 'POST', headers: {
                                          'Content-type': 'application/json',
                                      }, body: JSON.stringify(apiBody),
                                  })
                                      .then((response) => response.json())
                                      .catch((error) => {
                                          console.error('Error:', error);
                                      });

                                  let filteredArray = serverResponse.data.filter(item => item.projectID === e.value);

                                  $('#metaTable').DataTable().destroy()
                                  prepareMetaTableBody(filteredArray);
                                  $('#metaTable').DataTable().draw()

                              }
                              }

                    />
                </Col>


                <Col md={6}></Col>


            </Row>
             <br/>
             <br/>
            <table id='metaTable'
                   className='table'>
                <thead>
                <tr>
                    <th data-sortable='true' data-searchable='true'>
                        Datum
                    </th>
                    <th data-sortable='true' data-searchable='true'>
                        Typ
                    </th>
                    <th data-sortable='true' data-searchable='true'>
                        Titel
                    </th>
                    <th data-sortable='true' data-searchable='true'>
                        Ersteller
                    </th>
                    <th data-sortable='true' data-searchable='true'>
                        Status
                    </th>
                    <th className='centerStyle'>Aktivität</th>
                    <th className='centerStyle'>Webreport</th>
                </tr>
                </thead>
                <tbody
                    className='handwai-text-label-normal'>{metaTableBody}</tbody>
            </table>
            <br/> <br/>
        </div>
    </>);
}

export default memo(MetaComponent);